<mat-checkbox
  [(ngModel)]="showUserSelection"
  (change)="toogleUserSelection($event)"
>
  La persona está registrada en el sistema
</mat-checkbox>
<form [formGroup]="frm" class="formGroup">
  @if (showUserSelection) {
    <div class="w-100">
      <mat-form-field class="d-block my-2">
        <mat-label>Usuario</mat-label>
        <input
          #input
          type="text"
          placeholder="Seleccione un usuario"
          matInput
          formControlName="selectedUser"
          [matAutocomplete]="auto"
          (input)="filter()"
          (focus)="filter()"
        />
        @if (selectedUser.value) {
          <button mat-icon-button matSuffix (click)="unselectUser()">
            <mat-icon svgIcon="close"></mat-icon>
          </button>
        }
        <mat-autocomplete
          requireSelection
          #auto="matAutocomplete"
          [displayWith]="displayValue"
          (optionSelected)="selectUser($event)"
        >
          @for (option of autocompleteOptions; track option.id) {
            <mat-option [value]="option">{{
              option.firstname + ' ' + option.lastname
            }}</mat-option>
          }
        </mat-autocomplete>
        @if(selectedUser.hasError('required')){
          <mat-error>Seleccione un usuario</mat-error>
        }
      </mat-form-field>
    </div>

  }
  <mat-form-field>
    <mat-label>Nombre</mat-label>
    <input
      matInput
      formControlName="name"
      #firstInput
      (blur)="firstInputOnBlur()"
    />
    @if (name.hasError('required')) {
      <mat-error> Campo requerido </mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Apellidos</mat-label>
    <input matInput formControlName="lastname" />
    @if (lastname.hasError('required')) {
      <mat-error> Campo requerido </mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Email</mat-label>
    <input matInput formControlName="email" (blur)="firstInputOnBlur()" />
    @if (email.hasError('required')) {
      <mat-error>Campo requerido</mat-error>
    } @else if (email.hasError('pattern')) {
      <mat-error>Formato de correo incorrecto</mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Número telefónico</mat-label>
    @if (phone.errors) {
      <mat-hint>Formato requerido: 8 números (55125432)</mat-hint>
    }
    <input matInput formControlName="phone" maxlength="8" />
    @if (phone.hasError('required')) {
      <mat-error>Campo requerido</mat-error>
    } @else if (phone.hasError('pattern')) {
      <mat-error>Formato requerido: 8 números</mat-error>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>Fecha de nacimiento</mat-label>
    <input
      matInput
      [matDatepicker]="_birthday"
      formControlName="birthday"
      [max]="maxDate"
      (focus)="_birthday.open()"
    />
    <mat-datepicker-toggle
      matIconSuffix
      [for]="_birthday"
    ></mat-datepicker-toggle>
    <mat-datepicker #_birthday></mat-datepicker>
    @if (birthday.hasError('required')) {
      <mat-error> Formato inválido y este campo es requerido </mat-error>
    } @else if (birthday.hasError('matDatepickerMax')) {
      <mat-error>Fecha inválida, la persona debe ser mayor de edad</mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Carnet o pasaporte</mat-label>
    @if (dni.errors) {
      <mat-hint>Formato: 11 números o una letra con 6 números</mat-hint>
    }
    <input matInput formControlName="dni" maxlength="11" />
    @if (dni.hasError('required')) {
      <mat-error> Campo requerido </mat-error>
    } @else if (dni.hasError('pattern')) {
      <mat-error>
        Formato requerido: 11 números o una letra con 6 números</mat-error
      >
    }
  </mat-form-field>

  <t-llevo-image-input formControlName="photo"></t-llevo-image-input>
</form>
